// Copyright (c) 2016 Deere & Company

import './claim-rga-status-indicator.scss';
import React, {PropTypes} from 'react';
import ClaimRgaStatus from '@deere/cps-it.warranty-model-factory/lib/claim-rga-status';
import {FormattedMessage} from 'react-intl';

const claimRgaStatusText = {
    'Closed Requests': {
        text: 'CLOSED_PART_REQUESTS'
    },
    'Open Requests': {
        text: 'OPEN_PART_REQUESTS'
    },
    'Processed Requests': {
        text: 'PROCESSED_PART_REQUESTS'
    }
};

const claimRgaStatusClass = {
    NONE: {
        displayClass: ''
    },
    RED: {
        displayClass: 'dot-icon-red'
    },
    YELLOW: {
        displayClass: 'dot-icon-yellow'
    }
};

const formatClaimNumber = claimNumber => claimNumber.replace(/^0+/, '');

const ClaimRgaStatusIndicator = props => {

    const displayClass = props.claimRgaStatus.color ?
        claimRgaStatusClass[props.claimRgaStatus.color].displayClass : '';

    const text = claimRgaStatusText[props.claimRgaStatus.status].text;

    return (
        <div className='claim-rga-status'>
            <span className={displayClass}/>
            <a href={`#/part-requests/search?by=CLAIM&q=${formatClaimNumber(props.claim)}`}>
                <FormattedMessage id={text}/>
            </a>
        </div>
    );

};

ClaimRgaStatusIndicator.displayName = 'ClaimRgaStatusIndicator';
ClaimRgaStatusIndicator.propTypes = {
    claim: PropTypes.string.isRequired,
    claimRgaStatus: PropTypes.instanceOf(ClaimRgaStatus).isRequired
};

export default ClaimRgaStatusIndicator;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-rga-status-indicator.js